/** Light / dark theme. The cinematic site opens in dark; once the person chooses, their choice is remembered. */
import { local } from '../core/storage.js';

const KEY = 'vc.theme';

const DEFAULT = 'dark';

export function currentTheme() {
  const saved = local.get(KEY);
  return saved === 'light' || saved === 'dark' ? saved : DEFAULT;
}

export const isDark = () => currentTheme() === 'dark';

export function applyTheme() {
  document.documentElement.setAttribute('data-theme', currentTheme());
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', isDark() ? '#07081A' : '#F3F2FA');
}

export function toggleTheme() {
  local.set(KEY, isDark() ? 'light' : 'dark');
  applyTheme();
}
